import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["replacementSection", "select", "yes", "confirm", "hiddenInput", "variationId"];

  openModal(event) {
    event.preventDefault();
    const modal = document.getElementById(event.currentTarget.dataset.modalId);
    modal.classList.remove("hidden");

    this.replacementSectionTarget.classList.add("hidden");
    this.selectTarget.innerHTML = `<option value="">-- Select New exam variation --</option>`;
    this.hiddenInputTarget.value = "";
  }

  fetchOptions() {
    this.replacementSectionTarget.classList.remove("hidden");
    this.fetchAlternatives();
  }

  fetchAlternatives() {
    const variationId = this.variationIdTarget.value;

    fetch(`/assessment/exam_variations/${variationId}/alternatives`)
      .then(res => res.json())
      .then(data => {
        data.forEach(variation => {
          const option = document.createElement("option");
          option.value = variation.id;
          option.textContent = variation.name || `Variation ${variation.id}`;
          this.selectTarget.appendChild(option);
        });

        this.selectTarget.addEventListener("change", () => {
          this.hiddenInputTarget.value = this.selectTarget.value;
          this.confirmTarget.disabled = this.hiddenInputTarget.value === "";
        });

        this.yesTarget.style.display = "none";
        this.confirmTarget.classList.remove("visibility-hidden");
      });
  }

  confirmArchive() {
    const selectedOptionText = this.selectTarget.options[this.selectTarget.selectedIndex].text;
    const confirmMessage =
      `Warning: This action cannot be easily undone. Are you sure you want to replace this exam variation with ${selectedOptionText}?`;
    if (window.confirm(confirmMessage)) {
      this.sendArchiveRequest();
    }
    this.closeModal();
  }

  sendArchiveRequest() {
    const variationId = this.variationIdTarget.value;
    const replacementId = this.hiddenInputTarget.value || null;

    const body = {
      new_exam_variation_id: replacementId
    };

    fetch(`/assessment/exam_variations/${variationId}/set_archived`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify(body)
    }).then(() => window.location.reload());
  }

  cancel() {
    this.yesTarget.style.display = "block";
    this.confirmTarget.classList.add("visibility-hidden");
    this.confirmTarget.disabled = true;
    this.closeModal();
  }

  closeModal() {
    document.querySelectorAll(".gen-modal").forEach(m => m.classList.add("hidden"));
  }
}
